export default __webpack_public_path__ + "static/media/07.3b359d42.jpg";